export default __webpack_public_path__ + "0d28196ef1778fb48cb8161e6e20f687.png";